module.exports = __webpack_public_path__ + "img/ledgers.closed.weekly.13cdcad9.png";